import { render, staticRenderFns } from "./manualApproveTicketVoucher.vue?vue&type=template&id=3f4595a6&lang=pug"
import script from "./manualApproveTicketVoucher.vue?vue&type=script&lang=js"
export * from "./manualApproveTicketVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports